export const CHECKOUT_URL = 'https://renaldesk-en.impultienda.ar/checkout/'
